import { render, staticRenderFns } from "./insurance_list.vue?vue&type=template&id=035f08c5&scoped=true&"
import script from "./insurance_list.vue?vue&type=script&lang=js&"
export * from "./insurance_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f08c5",
  null
  
)

export default component.exports